import { useCurrentUser } from '@mp/hooks';
import React, { useEffect, useRef } from 'react';
import { useApplicationMutations } from '../../applicationFlowMutations';
import calendlyWidget from '@mp/utils/calendlyWidget';
import { config } from '@mp/config';

const schedulingCompleted = (e: MessageEvent) =>
  e.origin === 'https://calendly.com' && e.data.event === 'calendly.event_scheduled';

export const PhoneScreeningScheduler = () => {
  const { currentUser } = useCurrentUser();
  const { nextStepWithValues } = useApplicationMutations();
  const isPreScreening = currentUser?.professional?.application_version === 'prescreening';
  const calendlyURL = currentUser?.professional?.signup_assignment_id
    ? config.calendlyAssignmentURL
    : config.calendlyURL(isPreScreening);
  const name = `${currentUser?.first_name} ${currentUser?.last_name}`;
  const email = currentUser?.email;
  const a1 = currentUser?.phone_number;
  const processedEventRef = useRef(null);

  useEffect(() => {
    calendlyWidget();
  }, []);

  useEffect(() => {
    const handleMessage = (e: MessageEvent) => {
      if (schedulingCompleted(e)) {
        if (processedEventRef.current === e.data.payload.event.uri) {
          return;
        }
        processedEventRef.current = e.data.payload.event.uri;
        const payload = {
          calendly_scheduled_event_uri: e.data.payload.event.uri,
          calendly_scheduled_event_invitee_uri: e.data.payload.invitee.uri,
        };
        nextStepWithValues(payload);
      }
    };
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [nextStepWithValues]);

  return (
    <div
      className="calendly-inline-widget"
      data-url={`${calendlyURL}?name=${name}&email=${email}&a1=${a1}`}
      style={{ minWidth: 320, height: 700 }}
    />
  );
};
